import { guid } from '@/mixins/guid';

export function cardShape(mrg = {}) {
  return () =>
    Object.assign(
      {
        _id: guid.methods.guid(),
        img: `${process.env.S3_ASSETS_URL}mock-images/backgrounds/image-bg.svg`,
        pageLink: false,
        customLink: false,
        newWindow: false,
        title: 'Card Title',
        mediaQueries: [{
          selector: ' ',
          properties: [
            {
              property: 'background-image',
              desktop: `url('${process.env.S3_ASSETS_URL}mock-images/backgrounds/image-bg.svg')`,
              tablet: 'default',
              mobile: 'default',
            },
          ],
        }],
        text: 'Brooklyn four dollar toast edison bulb, selfies kale chips williamsburg gochujang neutra franzen',
      },
      mrg,
    );
}



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/utils.js